/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ArrowDown': {
    width: 7,
    height: 6,
    viewBox: '0 0 7 6',
    data: '<path pid="0" d="M2.84 5.645c-.034-.033-.178-.158-.297-.275C1.794 4.687.569 2.906.195 1.973c-.06-.141-.187-.5-.195-.69C0 1.098.042.923.127.757.247.55.433.383.654.292c.154-.059.613-.15.621-.15C1.777.05 2.594 0 3.495 0c.86 0 1.642.05 2.152.125.008.009.579.1.774.2.357.183.579.541.579.924v.033c-.009.25-.23.775-.239.775-.374.882-1.539 2.622-2.313 3.322 0 0-.199.197-.323.283-.179.133-.4.2-.62.2a1.09 1.09 0 01-.665-.217z" _fill="#243143" fill-opacity=".6"/>'
  }
})
